// extracted by mini-css-extract-plugin
export var equalColumn = "_e9-0";